export const toZoomImage = (src: string): string =>
	src?.replace('hclstore', 'wcsstore').replace(/normal|default/g, 'zoom') ?? src;
